import { FunctionComponent } from 'react';
import classnames from 'classnames';

import Button, { ButtonStyles } from 'components/layout/Button';
import Checkbox from 'components/layout/forms/Checkbox';
import { ValuesTypes as PrevStateTypes } from 'components/modules/public/pages/CompanySites/types';

import { Props } from './index';
import StyledComponent from './styles';

const PublicPageCompanySitesSectionHeroBlocksExpandableMenu: FunctionComponent<Props> = ({
    list,
    buttonProps,
    onChange,
    onSearch,
    values,
    onClose,
}) => {
    return (
        <StyledComponent
            className={classnames(
                'public-page-company-sites-section-hero-blocks-expandable-menu',
            )}
        >
            <div className="menu-wrapper">
                <div className="expandable-menu">
                    <div className="menu-header">
                        <div
                            className="header-title"
                            dangerouslySetInnerHTML={{ __html: '' }}
                        />
                        <Button
                            className="clear-control"
                            style={ButtonStyles.None}
                            onClick={ () => onChange('category', null, true)}
                            {...buttonProps?.clear}
                        />
                    </div>

                    <div className="menu-elements">
                        {Array.isArray(list) && list.map(element => (
                            <div
                                className="element"
                                key={element.id}
                            >
                                <Checkbox
                                    name={element.slug}
                                    label={element.name}
                                    onChange={ () => onChange('category', element.slug) }
                                    value={values.category.getValue().includes(element.slug)}
                                />
                            </div>
                        ))}
                    </div>

                    <div className="menu-control">
                        <Button
                            className="search-control"
                            onClick={() =>{
                                onSearch();
                                onClose();
                            }}
                            {...buttonProps?.search}
                        />
                    </div>
                </div>
            </div>
        </StyledComponent>
    );
};

export default PublicPageCompanySitesSectionHeroBlocksExpandableMenu;